import { Moment } from 'moment';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import moment from 'moment/moment';
import { Organization } from './organization';
import { Vendor } from 'app/models/entities/vendors/vendor';
import { Category } from './accounting/category';
import { User } from './user';
import { LobBankAccount } from './lob-bank-account';

export class PrintableCheck
{
    id: number;
    organizationId: number;
    payee: string;
    vendorId: number;
    amount: number;
    amountInWords: string;
    formattedAmount: string;
    checkNumber: number;
    memo: string;
    createdBy: number;
    status: string;
    statusMessage: string;
    cancelledBy: User;

    category: Category;
    lobBankAccount: LobBankAccount;
    account: LobBankAccount;

    checkDate: Moment;
    cashedDate: Moment;
    cancelledAt: Moment;
    createdAt: Moment;
    updatedAt: Moment;
    deletedAt: Moment;

    organization: Organization;
    vendor: Vendor;

    constructor(check: any) {
        if (check.id) {
            this.id = check.id;
        }
        if (check.organizationId) {
            this.organizationId = check.organizationId;
        }
        if (check.payee) {
            this.payee = check.payee;
        }
        if (check.vendorId) {
            this.vendorId = check.vendorId;
        }
        if (check.amount) {
            this.amount = check.amount;
        }
        if (check.formattedAmount) {
            this.formattedAmount = check.formattedAmount;
        }
        if (check.amountInWords) {
            this.amountInWords = check.amountInWords;
        }
        if (check.checkNumber) {
            this.checkNumber = check.checkNumber;
        }
        if (check.checkDate) {
            this.checkDate = moment(check.checkDate);
        }
        if (check.cashedDate) {
            this.cashedDate = moment(check.cashedDate);
        }
        if (check.memo) {
            this.memo = check.memo;
        }
        if (check.createdBy) {
            this.createdBy = check.createdBy;
        }
        if (check.category) {
            this.category = new Category(check.category);
        }
        if (check.lobBankAccount) {
            this.lobBankAccount = new LobBankAccount(check.lobBankAccount);
        }
        if (check.account) {
            this.account = new LobBankAccount(check.account);
        }
        if (check.cancelledBy) {
            this.cancelledBy = new User(check.cancelledBy);
        }
        if (check.status) {
            this.status = check.status;
        }
        if (check.statusMessage) {
            this.statusMessage = check.statusMessage;
        }

        const timezone = LegFiJwtService.getTimezone();
        if (check.createdAt) {
            this.createdAt = moment.utc(check.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (check.updatedAt) {
            this.updatedAt = moment.utc(check.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (check.deletedAt) {
            this.deletedAt = moment.utc(check.deletedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (check.cancelledAt) {
            this.cancelledAt = moment.utc(check.cancelledAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (check.organization) {
            this.organization = new Organization(check.organization);
        }
        if (check.vendor) {
            this.vendor = new Vendor(check.vendor);
        }
    }
}
